import { BaseEntity } from "../../../models/concrete/BaseEntity.mjs";
export class Product extends BaseEntity {
  code;
  name;
  slug;
  description;
  shortDescription;
  price;
  oldPrice;
  newPrice;
  rating;
  imageId;
  imageIds;
  quantity;
  countStep;
  depth;
  weight;
  width;
  height;
  isHit;
  isExclusive;
  isPromo;
  promoName;
  isNew;
  isSpecial;
  url;
  allowOutOfStock;
  unit;
  category;
  categories;
  tags;
  photos;
  characteristics;
  stores;
  brand;
  modifications;
  customDataFields;
  variants;
  hasModifications;
  productSetImageDots;
  options;
  isProductSet;
  isNotAvailable;
  hasOptions;
  modificationsCount;
  optionGroupsCount;
  sku;
  productSetParents;
  files;
  reviewsCount;
  reviewsRating;
  productSetChildrenCount;
  bonusValue;
  totalBonusValue;
  shortCharacteristics;
  additionalCategories;
  characteristicGroup;
  characteristicGroupId;
  isBonusesOutcoming;
  exchangeUpdatedAt;
  createdAt;
  updatedAt;
  image;
  images;
  videos;
  promotions;
  meta;
  dynamicFields;
  countInPack;
  constructor(data, meta) {
    super(data);
    this.code = data.code;
    this.name = data.name;
    this.slug = data.slug;
    this.description = data.description;
    this.shortDescription = data.short_description;
    this.price = data.price;
    this.oldPrice = data.price_old;
    this.newPrice = data.price_new;
    this.rating = data.rating;
    this.imageId = data.image_id;
    this.imageIds = data.images_ids;
    this.videos = data.videos;
    this.quantity = data.quantity;
    this.countStep = data.count_step;
    this.depth = data.depth;
    this.weight = data.weight;
    this.width = data.width;
    this.height = data.height;
    this.isHit = data.is_hit;
    this.isExclusive = data.is_exclusive;
    this.isPromo = data.is_promo;
    this.promoName = data.promo_name;
    this.isNew = data.is_new;
    this.isSpecial = data.is_special;
    this.url = data.url;
    this.allowOutOfStock = data.allow_out_of_stock;
    this.unit = data.unit;
    this.countInPack = data.count_in_pack;
    this.category = {
      id: data?.category?.id,
      name: data?.category?.name
    };
    this.categories = data.categories?.map((c) => ({
      id: c.id,
      parentId: c.parent_id,
      name: c.name,
      slug: c.slug
    }));
    this.tags = data.tags;
    this.photos = data.photos?.map((p) => ({
      caption: p.caption,
      preview: p.preview,
      src: p.src,
      thumb: p.thumb
    }));
    this.characteristics = data.characteristics?.map((c) => ({
      name: c.name,
      characteristics: c.characteristics?.map((c2) => ({
        id: c2.id,
        name: c2.name,
        slug: c2.slug,
        values: c2?.values.map((v) => ({
          id: v.id,
          slug: v.slug,
          value: v.value,
          imageId: v.image_id,
          sort: v.sort
        })),
        help: c2.help,
        unit: c2.unit,
        showInFilter: c2.show_in_filter,
        nameForFilter: c2.name_for_filter,
        nameForProduct: c2.name_for_product,
        nameForProductCard: c2.name_for_product_card,
        showInProduct: c2.show_in_product,
        showInProductCard: c2.show_in_product_card,
        hideNameOnProduct: c2.hide_name_on_product,
        hideNameOnProductCard: c2.hide_name_on_product_card,
        filterTemplate: c2.filter_template,
        viewTemplate: c2.view_template,
        filterType: c2.type,
        sort: c2.sort
      }))
    }));
    this.stores = data.stores?.map((s) => ({
      address: s.address,
      cellPhone: s.cell_phone,
      cityId: s.city_id,
      cityName: s.city_name,
      hasPickup: s.has_pickup,
      id: s.id,
      images: s.images,
      lat: s.lat,
      lon: s.lon,
      title: s.title,
      url: s.url,
      workPhone: s.work_phone,
      description: s.description,
      email: s.email,
      image: s.image,
      workingHours: s.working_hours,
      imageId: s.image_id,
      imagesIds: s.images_ids
    }));
    this.brand = {
      id: data.brand?.id,
      name: data.brand?.name,
      url: data.brand?.url,
      country: data.brand?.country,
      description: data.brand?.description,
      image: data.brand?.image,
      secondTitle: data.brand?.second_title,
      sort: data.brand?.sort
    };
    this.modifications = data.modifications?.map((m) => ({
      id: m.id,
      name: m.name,
      price: m.price,
      quantity: m.quantity,
      variants: m.variants.map((v) => ({
        id: v.id,
        label: v.label,
        image: v.image
      })),
      oldPrice: m.price_old
    }));
    this.customDataFields = data.customDataFields;
    this.variants = data.variants?.map((v) => ({
      groupId: v.group_id,
      name: v.name,
      variants: v.variants?.map((v2) => ({
        id: v2.id,
        label: v2.label,
        image: v2.image
      }))
    }));
    this.hasModifications = data.has_modifications;
    this.productSetImageDots = data.product_set_image_dots;
    this.options = data.options?.map((opt) => ({
      name: opt.name,
      sort: opt.sort,
      id: opt.id,
      isMultiple: opt.isMultiple,
      variants: opt.variants?.map((variant) => ({
        characteristicVariants: variant.characteristic_variants || variant.characteristicVariants,
        name: variant.name,
        depth: variant.depth,
        imageId: variant.image_id,
        isProduct: variant.is_product,
        id: variant.id,
        exclusionIds: variant.exclusion_ids,
        height: variant.height,
        price: variant.price,
        sort: variant.sort,
        imagesIds: variant.image_ids,
        priceOld: variant.price_old,
        priceOldValue: variant.price_old_value,
        priceType: variant.price_type,
        priceValue: variant.price_value,
        seats: variant.seats,
        sizeDepth: variant.size_depth,
        sizeHeight: variant.size_height,
        sku: variant.sku,
        variantGroupId: variant.variant_group_id,
        sizeLength: variant.size_length,
        sizeWidth: variant.size_width,
        volume: variant.volume,
        weight: variant.weight,
        width: variant.width
      }))
    }));
    this.isProductSet = data.is_product_set;
    this.isNotAvailable = data.is_not_available;
    this.hasOptions = data.has_options;
    this.modificationsCount = data.modifications_count;
    this.optionGroupsCount = data.option_groups_count;
    this.sku = data.sku;
    this.productSetParents = data.productSetParents;
    this.files = data.files;
    this.reviewsCount = data.reviews_count;
    this.reviewsRating = data.reviews_rating;
    this.productSetChildrenCount = data.product_set_children_count;
    this.bonusValue = data.bonus_value;
    this.totalBonusValue = data.bonus_value_total;
    this.shortCharacteristics = data?.short_characteristics?.map((c) => ({
      id: c.id,
      name: c.name,
      slug: c.slug,
      values: c?.values.map((v) => ({
        id: v.id,
        slug: v.slug,
        sort: v.sort,
        value: v.value,
        imageId: v.image_id
      })),
      help: c.help,
      unit: c.unit,
      showInFilter: c.show_in_filter,
      nameForFilter: c.name_for_filter,
      nameForProduct: c.name_for_product,
      nameForProductCard: c.name_for_product_card,
      showInProduct: c.show_in_product,
      showInProductCard: c.show_in_product_card,
      hideNameOnProduct: c.hide_name_on_product,
      hideNameOnProductCard: c.hide_name_on_product_card,
      filterTemplate: c.filter_template,
      viewTemplate: c.view_template,
      filterType: c.type
    }));
    this.additionalCategories = data.additionalCategories;
    this.characteristicGroup = data.characteristicGroup;
    this.characteristicGroupId = data.characteristic_group_id;
    this.isBonusesOutcoming = data.is_bonuses_outcoming;
    this.exchangeUpdatedAt = data.exchange_updated_at;
    this.createdAt = data.created_at;
    this.updatedAt = data.updated_at;
    this.image = data.image;
    this.images = data.images?.map((i) => ({
      src: i.src,
      preview: i.preview,
      thumb: i.thumb,
      caption: i.caption,
      imageId: i.imageId
    }));
    this.promotions = data.promotions?.map((p) => {
      let dynamicFields2 = { ...p };
      [
        "id",
        "started_at",
        "ended_at",
        "slug",
        "url",
        "label",
        "icon_file_id",
        "icon",
        "description",
        "visual_profit_label",
        "visual_profit_type",
        "visual_profit_value",
        "is_credit"
      ].map((key) => {
        delete dynamicFields2[key];
      });
      return {
        id: p.id,
        startedAt: p.started_at ? new Date(p.started_at) : void 0,
        endedAt: p.ended_at ? new Date(p.ended_at) : void 0,
        slug: p.slug,
        url: p.url,
        label: p.label,
        iconFileId: p.icon_file_id,
        icon: p.icon,
        description: p.description,
        visualProfitLabel: p.visual_profit_label,
        visualProfitType: p.visual_profit_type,
        visualProfitValue: p.visual_profit_value,
        credit: !p.is_credit ? void 0 : {
          is: p.is_credit,
          percent: p.credit_percent,
          term: p.credit_term,
          type: p.credit_type
        },
        dynamicFields: dynamicFields2
      };
    });
    this.meta = meta;
    const dynamicFields = { ...data };
    [
      "code",
      "name",
      "slug",
      "description",
      "short_description",
      "price",
      "price_old",
      "price_new",
      "rating",
      "image_id",
      "images_ids",
      "quantity",
      "count_step",
      "depth",
      "weight",
      "width",
      "height",
      "is_hit",
      "is_exclusive",
      "is_new",
      "is_special",
      "url",
      "allow_out_of_stock",
      "unit",
      "category",
      "categories",
      "tags",
      "photos",
      "characteristics",
      "stores",
      "brand",
      "modifications",
      "customDataFields",
      "variants",
      "has_modifications",
      "product_set_image_dots",
      "options",
      "is_product_set",
      "is_not_available",
      "has_options",
      "modifications_count",
      "option_groups_count",
      "productSetParents",
      "files",
      "reviews_count",
      "reviews_rating",
      "product_set_children_count",
      "bonus_value",
      "bonus_value_total",
      "short_characteristics",
      "additionalCategories",
      "characteristicGroup",
      "characteristic_group_id",
      "is_bonuses_outcoming",
      "exchange_updated_at",
      "created_at",
      "updated_at",
      "image",
      "images",
      "promotions",
      "meta"
    ].map((key) => {
      delete dynamicFields[key];
    });
    this.dynamicFields = dynamicFields;
  }
  toJSON() {
    return { ...this };
  }
}
